<template>
    <div>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <!-- Sticky header: title + Back + Save buttons, outside v-container -->
        <div class="fs-sticky-header">
            <div class="fs-sticky-title">
                <h2 class="mb-0">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-2">{{ this.parentObject.pageTitleValue }}</span></h2>
            </div>
            <div class="fs-sticky-actions">
                <v-btn color="warning" class="fbtn mr-2" @click="backHandler">
                    {{$t('button.back')}}
                </v-btn>
                <v-btn color="success" class="fbtn" @click="saveHandler">
                    {{$t('button.save')}}
                </v-btn>
            </div>
        </div>

        <v-container class="mb-10" style="max-width:100%;overflow-x:hidden;">
            <v-form ref="form">

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5 mb-10"
                >

                    <div>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffcode')"
                                    ref="staffcode"
                                    readonly
                                    :rules="[rules.required]"
                                    v-model="formData.staffcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="8" sm="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffname')"
                                    ref="staffname"
                                    readonly
                                    :rules="[rules.required]"
                                    v-model="formData.staffname"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodstartdate')"
                                    ref="asofdate1"
                                    type="date"
                                    :rules="[rules.required]"
                                    v-model="formData.periodstartdate"
                                    dense
                                ></v-text-field>
                            </v-col>


                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodenddate')"
                                    ref="asofdate1"
                                    type="date"
                                    :rules="[rules.required]"
                                    v-model="formData.periodenddate"
                                    dense
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.status')"
                                    type="text"
                                    :items="this.statusList"
                                    hide-selected
                                    v-model="formData.kpirecstatusid"
                                    @change="handleStatusChange"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="9" sm="9" class="pb-n5 mt-n6">
                                <v-autocomplete
                                    outlined
                                    :label="$t('appraisalrecord.reviewer')"
                                    type="text"
                                    :items="this.staffList"
                                    hide-selected
                                    v-model="formData.reviewerid"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- Add Objective -->
                    <div class="mb-10">
                        <v-row>
                            <app-table
                                @add-individual-kpi="handleAddIndividualKpi"
                                @add-selected-commonkpi="handleAddSelectedCommonKpi" 
                                v-bind:parentObject = "{
                                    periodstartdate: formData.periodstartdate,
                                    periodenddate: formData.periodenddate,
                                }"
                            />
                        </v-row>
                    </div>
                </v-container>
                
                <!-- Individual KPI -->
                <div v-if="individualCard" class="mt-n4">
                    <div v-for="(item, index) in individualKPIList" :key="index" class="mx-4">
                        <app-card-individual
                            @reload-individual-kpi="reloadIndividualKPI"
                            :key="reloadKey"
                            v-bind:parentObject="{
                                formData: item,
                                staffid: parentObject.item.staffid,
                                reviewerid: formData.reviewerid,
                                tabHeader: item.tabHeader,
                                detailItem: item.detailItem,
                                isWizard: item.isWizard
                            }"
                        />
                    </div>
                </div>
                <!-- Common KPI -->
                <div v-if="individualSelectedCommonCard" class="mt-2">
                    <div v-for="(item, index) in individualSelectedCommonKPIList" :key="index" class="mx-4">
                        <app-card-common
                            v-bind:parentObject = "{
                                commonKPI: item,
                            }"
                        />
                    </div>
                </div>
            </v-form>
        </v-container>
    </div>
</template>

<script>

//import moment from 'moment'
import CRUDTable from './CRUDTableStaffExercise';
import KPICardIndividual from "./KPICardIndividual";
import KPICardCommon from "./KPICardCommon";

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-table': CRUDTable,
        "app-card-individual": KPICardIndividual,
        "app-card-common": KPICardCommon,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },
            formData: this.parentObject.item,
            kpiexerformData: this.parentObject.data,
            individualCard : false,
            individualSelectedCommonCard : false,
            staffList: [],
            statusList: [],
            individualKPIList: [],
            individualSelectedCommonKPIList: [],

            companyname: [],
            companyList: [],
            errMsg: "",
            isErr: false,

            reloadKey: 0, // 🔄 Used to force reactivity after delete

            kpisettingstatus: [],

            ratingscalesetdetail: [
                {ratingcode: 1},
            ],

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.staffcode'), value: 'ratingcode', width: '200px', sortable: true},
                { text: this.$t('columns.name'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.reviewer'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.reviewername'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.status'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('performancemanagement.objectivereviewer'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('performancemanagement.reviewerstaffcode'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.company'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.branch'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.department'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.section'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.unit'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.grade'), value: 'label', width: '200px', sortable: true},
                { text: this.$t('columns.position'), value: 'label', width: '200px', sortable: true},
            ],
        }
    },

    methods: {
        handleAddIndividualKpi() {
            this.loadIndividualKPIList();
            // this.individualKPIList.push(newData); 
        },

        reloadIndividualKPI() {
            this.loadIndividualKPIList();
            this.reloadKey++; // force update
        },

        handleAddSelectedCommonKpi() {
            this.loadIndividualSelectedCommonKPIList(); 
        },

        loadIndividualKPIList() { 
            const vm = this;

            this.$store.dispatch('get', { url: "/kpiindividual/" + vm.formData.id })
                .then((res) => {

                    vm.individualKPIList = res.data.rec;
                    if (vm.individualKPIList.length > 0) {
                        vm.individualCard = true;
                    }
                }).catch((err) => {
                    console.error(err);
                });

        },

        loadIndividualSelectedCommonKPIList() {
            const vm = this;

            this.$store.dispatch('get', { url: "/kpiindividual/selectedcommon/" + vm.formData.id })
                .then((res) => {

                    vm.individualSelectedCommonKPIList = res.data.rec;
                    if (vm.individualSelectedCommonKPIList.length > 0) {
                        vm.individualSelectedCommonCard = true;
                    }
                }).catch((err) => {
                    console.error(err);
                });

        },

        handleStatusChange() {
            const selectedValue = this.formData.kpirecstatusid;
            const selectedItem = this.statusList.find(item => item.value === selectedValue);
            if (selectedItem) {
                this.formData.kpirecstatusid = selectedItem.value;
                this.formData.kpiexerrecstatus = selectedItem.text;
            }
        },

        loadStaffList() {
            const vm = this;
            // const today = new Date();

            this.$store.dispatch('get', { url: "/staff/all/" + this.$store.getters.userId })
                .then((res) => {

                    const staffRecords = res.data.rec;

                    // // Filter staff records where cessadate > today's date
                    // const filteredStaff = staffRecords.filter(staff => {
                    //     const cessadate = new Date(staff.cessadate);
                    //     return cessadate > today && staff.id !== this.parentObject.item.staffid;
                    // });

                    vm.staffFull = staffRecords;

                    // Populate staffList with filtered data
                    vm.staffList = staffRecords.map(staff => ({
                        text: staff.psndetails,
                        value: staff.id,
                    }));

                }).catch((err) => {
                    console.error(err);
                });

        },

        async fetchStatusRec() {

            const vm = this;

            // Dispatch the post request with the payloads object
            await this.$store.dispatch('get', { url: "/kpiexerciserecstatus/all" })
                .then((res) => {

                    if (res.status == 200) {
                        const statusRecords = res.data.rec;

                        // Populate statusList with appropriate data
                        vm.statusList = statusRecords.map(status => ({
                            text: status.kpiexerrecstatus,
                            value: status.id,
                        }));

                    } else {
                        vm.isErr = !vm.isErr;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });

        },

        backHandler() {
            this.$router.push({ name: 'kpisettingstaff', params: { id: this.parentObject.data.id } });
        },

        saveHandler() {
            const vm = this;

            console.log(vm.formData);
            console.log(vm.statusList);
            console.log(vm.kpiexerformData);

            this.$store.dispatch('put', { url: "/kpiexercisestaff/" + this.$store.getters.userId, payload: { formData: vm.formData, statusList: vm.statusList, kpiexerformData: vm.kpiexerformData } })
                .then((res) => {
                    if (res.data.error) {
                        if (Array.isArray(res.data.error)) {
                            vm.isErr = !vm.isErr;
                            vm.errMsg = res.data.error.join(", ");
                        } else {
                            vm.isErr = !vm.isErr;
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        this.backHandler();
                    }
                })
                .catch((err) => {
                    if (Array.isArray(err)) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = err.join(", ");
                    } else {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = err;
                    }
                });
        },
    }, 

    mounted() { 
        this.loadStaffList();
        this.fetchStatusRec();
        this.loadIndividualKPIList();
        this.loadIndividualSelectedCommonKPIList();
    },
    
}
</script>

<style scoped>
/* Sticky bar containing title + Back/Save buttons */
.fs-sticky-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #ffffff;
    padding: 10px 24px 10px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E8EDF5;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.fs-sticky-title h2 {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1E293B;
    line-height: 1.3;
}

.fs-sticky-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.fbtn {
    min-width: 80px !important;
    height: 36px !important;
    border-radius: 8px !important;
    font-size: 0.82rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    box-shadow: none !important;
}
</style>